/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RestResponse,  Board } from '../model';
import { environment } from '../../environments/environment';
import { ApiHeaders } from './headers';

@Injectable()
export class BoardProvider {

  constructor(
    private http: HttpClient
  ) {
  }

  getAllBoards(page: number, query?: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/board/list?page=${page}${query ? '&query=' + encodeURIComponent(query) : ''}`,
        ApiHeaders.getOptions());
  }

  getUserBoards(type: string, query?: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/board/list/userboards?type=${type}${query ? '?query=' + encodeURIComponent(query) : ''}`,
        ApiHeaders.getOptions());
  }

  getBoard(id: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/board/${id}`, ApiHeaders.getOptions());
  }

  saveBoard(board: Board): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/board`, board, ApiHeaders.getOptions());
  }

  setDefaultBoard(board: Board): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/board/default`, board, ApiHeaders.getOptions());
  }

  unSetDefaultBoard(board: Board): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/board/undefault`, board, ApiHeaders.getOptions());
  }

  deleteBoard(id: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/board/${id}/delete`, null, ApiHeaders.getOptions());
  }

}
